import i18next from 'i18next';

export const yesNoCollection = () => [
  {
    id: true,
    name: i18next.t('common.yes-no.yes')
  },
  {
    id: false,
    name: i18next.t('common.yes-no.no')
  }
];
